// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_cn-j";
export var fulfillmentFormRail = "_cn-i";
export var headerTitleRow = "_cn-l";
export var orderDetailsWrapper = "_cn-g";
export var orderLinkTrigger = "_cn-2";
export var paymentInformationGrid = "_cn-q";
export var paymentSummaryColumn = "_cn-r";
export var phoneShipmentPickerButton = "_cn-e";
export var phoneShipmentPickerButtonContent = "_cn-f";
export var phoneShipmentPickerButtonWrapper = "_cn-d";
export var phoneShipmentPickerTrigger = "_cn-c";
export var shipmentContainer = "_cn-k";
export var shipmentDetailsMainPane = "_cn-h";
export var shipmentNavigationCard = "_cn-a";
export var shipmentNavigationEdgeTrigger = "_cn-6";
export var shipmentNavigationRail = "_cn-3";
export var shipmentNavigationRailEnter = "_cn-5";
export var shipmentNavigationRailHeader = "_cn-9";
export var shipmentNavigationRailOverlay = "_cn-4";
export var shipmentNavigationScrim = "_cn-7";
export var shipmentSummaryFact = "_cn-n";
export var shipmentSummaryGrid = "_cn-m";
export var shipmentSummaryMetadataRow = "_cn-o";
export var shipmentSummaryTags = "_cn-p";
export var shipmentWorkspace = "_cn-0";
export var shipmentWorkspaceBodyTablet = "_cn-8";
export var shipmentWorkspaceContent = "_cn-b";
export var shipmentWorkspaceHeader = "_cn-1";